import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-sm text-gray-900" }
const _hoisted_3 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "text-sm italic text-gray-500"
}
const _hoisted_7 = { class: "divide-y divide-gray-100" }
const _hoisted_8 = { class: "flex items-center justify-between gap-6 pb-5" }
const _hoisted_9 = { class: "min-w-0" }
const _hoisted_10 = { class: "text-[13px] leading-relaxed text-gray-500" }
const _hoisted_11 = { class: "pt-5" }
const _hoisted_12 = { class: "divide-y divide-gray-100" }
const _hoisted_13 = { class: "flex items-center justify-between gap-6 pb-5" }
const _hoisted_14 = { class: "pt-5 space-y-5" }
const _hoisted_15 = { class: "flex items-center justify-between gap-6" }
const _hoisted_16 = {
  key: 0,
  class: "grid gap-5 sm:grid-cols-2"
}

import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import ImageUploaderNeue from '@/components/neue/ImageUploaderNeue.vue'
import InputArea from '@/components/neue/InputArea'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueToggle from '@/components/neue/NeueToggle'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TheModal from '@/components/TheModal.vue'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { useSettingsForm } from '@/composables/useSettingsForm'
import { timezonesFor } from '@/config/timezones'
import api from '@/store/api'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsCompany',
  setup(__props) {

const store = useStore()
const { user, hasFullAccess } = useSettingsAccess()
const {
  values,
  editing,
  faviconPreview,
  financialEnabled,
  autoArchiveInactiveEnabled,
  archiveInactiveDaysValid,
  onInactiveToggle,
  onFaviconChange,
  onFaviconRemove
} = useSettingsForm()

const countryTimestamp = ref(Date.now())
const timezoneOptions = computed(() =>
  Object.entries(timezonesFor(store.getters.country)).map(([name, value]) => ({ name, value }))
)

watch(
  () => store.getters.country,
  () => {
    countryTimestamp.value = Date.now()
  }
)

const setTimeZone = value => {
  values.time_zone = value
  editing.time_zone = true
}

const changeFavicon = event => {
  onFaviconChange(event)
  editing.favicon = true
}

const removeFavicon = () => {
  onFaviconRemove()
  editing.favicon = true
}

const greetingDescription = computed(() =>
  values.voicemail_enabled
    ? 'Read aloud to callers in a synthetic voice before the beep. Leave it blank to go straight to the beep.'
    : 'Read aloud to callers in a synthetic voice before the call ends. Leave it blank for a standard apology.'
)

const setVoicemailEnabled = value => {
  values.voicemail_enabled = value
  editing.voicemail_enabled = true
}

const setGreeting = value => {
  values.read_voicemail_message = value
  editing.read_voicemail_message = true
}

const setArchiveOnOptOut = value => {
  values.autoArchiveOnOptOut = value
  editing.autoArchiveOnOptOut = true
}

const setInactiveDays = value => {
  values.autoArchiveInactiveDays = value === '' ? NaN : Number(value)
  editing.autoArchiveInactiveDays = true
}

const modalOpen = ref(false)
const pin = ref('')
const flash = ref(false)

const saveFinancial = () => {
  if (financialEnabled.value) {
    api.call('POST', 'profile/validate?pin=' + pin.value, {}, { save: false }).then(data => {
      if (data.data.valid) {
        api.call('PUT', 'profile', { profile: { financial_data_pin: null } })
        financialEnabled.value = false
        modalOpen.value = false
        pin.value = ''
        store.commit('SET_HIDE_NUMBERS', false)
      } else {
        flash.value = true
        setTimeout(() => {
          flash.value = false
        }, 200)
      }
    })
  } else {
    api.call('PUT', 'profile', { profile: { financial_data_pin: pin.value } })
    financialEnabled.value = true
    modalOpen.value = false
    pin.value = ''
    store.commit('SET_HIDE_NUMBERS', true)
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    overlay: _withCtx(() => [
      _createVNode(TheModal, {
        "is-open": modalOpen.value,
        "modal-title": "Enter PIN",
        onCloseModal: _cache[2] || (_cache[2] = $event => (modalOpen.value = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_unref(FormSection), null, {
            default: _withCtx(() => [
              _createVNode(_unref(FormElement), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(InputField), {
                    modelValue: pin.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((pin).value = $event)),
                    name: "PIN",
                    onKeyup: _withKeys(saveFinancial, ["enter"])
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_unref(NeueButton), {
            type: "secondary",
            onClick: _cache[1] || (_cache[1] = $event => (modalOpen.value = false))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(NeueButton), {
            type: flash.value ? 'red' : 'primary',
            onClick: saveFinancial
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Save", -1)
            ]))]),
            _: 1
          }, 8, ["type"])
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Business details",
        description: "Your username, the sender on your customer notification emails, and your time zone."
      }, {
        default: _withCtx(() => [
          (_unref(hasFullAccess))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Username", -1)),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(values).handle), 1),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-1 text-[13px] leading-relaxed text-gray-500" }, [
                  _createTextVNode(" Contact "),
                  _createElementVNode("a", {
                    href: "mailto:team@bottle.com",
                    class: "underline"
                  }, "team@bottle.com"),
                  _createTextVNode(" to change it. ")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_unref(hasFullAccess))
              ? (_openBlock(), _createBlock(_unref(InputField), {
                  key: 0,
                  modelValue: _unref(values).email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(values).email) = $event)),
                  name: "System notification email",
                  type: "email",
                  description: "The sender on the notification emails your customers receive.",
                  placeholder: "michael@bluthcompany.com",
                  onInput: _cache[4] || (_cache[4] = $event => (_unref(editing).email = true))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_unref(SelectInput), {
              key: `${_unref(store).getters.country}-${countryTimestamp.value}`,
              name: "Time zone",
              options: timezoneOptions.value,
              "model-value": _unref(values).time_zone,
              disabled: !_unref(hasFullAccess),
              "onUpdate:modelValue": setTimeZone
            }, null, 8, ["options", "model-value", "disabled"]))
          ])
        ]),
        _: 1
      }),
      (_unref(hasFullAccess))
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 0,
            title: "Checkout favicon",
            description: "The small icon in the browser tab while customers shop and check out. Upload a PNG."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_unref(faviconPreview))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(faviconPreview),
                      alt: "Current favicon",
                      class: "h-12 w-12 rounded border border-gray-200"
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, "No favicon yet")),
                (_unref(faviconPreview))
                  ? (_openBlock(), _createBlock(_unref(NeueButton), {
                      key: 2,
                      type: "secondary",
                      onClick: removeFavicon
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("Remove favicon", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(ImageUploaderNeue, {
                files: [],
                retained: true,
                multiple: false,
                accept: "image/png",
                onChange: changeFavicon
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(hasFullAccess) && !_unref(user)?.attributes?.disable_hide_financial_data)
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 1,
            title: "Privacy",
            description: "Hide financial information across the dashboard behind a PIN.",
            flush: ""
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Hide financial information"),
                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "You need the PIN to turn this off again.")
              ], -1)),
              _createVNode(_unref(NeueToggle), {
                "model-value": _unref(financialEnabled),
                onChange: _cache[5] || (_cache[5] = $event => (modalOpen.value = true))
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(hasFullAccess))
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 2,
            title: "Phone",
            description: "What callers hear when nobody picks up your Bottle number."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Accept voicemail", -1)),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(values).voicemail_enabled
                  ? 'Callers can leave a message after the greeting. Messages show up in your inbox.'
                  : 'Callers hear the greeting and the call ends. Missed calls still show up in your inbox.'), 1)
                  ]),
                  _createVNode(_unref(NeueToggle), {
                    "model-value": _unref(values).voicemail_enabled,
                    "aria-label": "Accept voicemail",
                    onChange: setVoicemailEnabled
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(InputArea), {
                    "model-value": _unref(values).read_voicemail_message,
                    name: "Greeting",
                    rows: 3,
                    counter: false,
                    placeholder: "Thanks for calling. We can't pick up right now, but you can order any time at our online store.",
                    description: greetingDescription.value,
                    "onUpdate:modelValue": setGreeting
                  }, null, 8, ["model-value", "description"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(hasFullAccess))
        ? (_openBlock(), _createBlock(SettingsSection, {
            key: 3,
            title: "Archiving",
            description: "Keep your customer list current by archiving customers who have stopped engaging."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "min-w-0" }, [
                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Archive customers who opt out of texts"),
                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Customers are archived once they opt out of receiving your texts. ")
                  ], -1)),
                  _createVNode(_unref(NeueToggle), {
                    "model-value": _unref(values).autoArchiveOnOptOut,
                    onChange: setArchiveOnOptOut
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Archive inactive customers"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Archives customers after a stretch with no activity. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      "model-value": _unref(autoArchiveInactiveEnabled),
                      onChange: _unref(onInactiveToggle)
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  (_unref(autoArchiveInactiveEnabled))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_unref(InputField), {
                          "model-value": _unref(values).autoArchiveInactiveDays,
                          name: "Days without activity",
                          suffix: "days",
                          restrict: "integer",
                          error: !_unref(archiveInactiveDaysValid),
                          description: 
                _unref(archiveInactiveDaysValid) ? 'Between 30 and 730 days.' : 'Enter a value between 30 and 730 days.'
              ,
                          "onUpdate:modelValue": setInactiveDays
                        }, null, 8, ["model-value", "error", "description"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}